export default __webpack_public_path__ + "static/media/pukanina3.ed27566b.jpg";